import useIsTouchscreen from "./useIsTouchscreen";

export default useIsTouchscreen;
